// @flow
import { ACTIONS_NAMESPACE as CB_ACTIONS_NAMESPACE } from '../constants';

export const ACTIONS_NAMESPACE = `${CB_ACTIONS_NAMESPACE}/CONFIRMATIONS`;

export const MOUNT_POINT = 'confirmations';

export const ASK_FOR_CONFIRMATION = `${ACTIONS_NAMESPACE}/ASK_FOR_CONFIRMATION`;
export const CLOSE = `${ACTIONS_NAMESPACE}/CLOSE`;
export const PROCEED = `${ACTIONS_NAMESPACE}/PROCEED`;

export const ACTION_TYPE = 'ACTION_TYPE';

export const DEFAULT_MESSAGE = '__default__';
